import { getAccounts } from '../apis/admin'
import { getProjectPath } from '../apis/project'

export type ApiAccountOwners = { [accountId: string]: { name: string } }

export const resolveApiAccountOwners = async (
  projectId: string
): Promise<ApiAccountOwners> => {
  const owners: ApiAccountOwners = {}

  try {
    const pathItems: { id: string }[] = (await getProjectPath(projectId)) || []

    const projects = [...pathItems, { id: projectId }].filter(
      (p, index, all) => all.findIndex(other => other.id === p.id) === index
    )

    const results = await Promise.all(
      projects.map(project =>
        getAccounts(project.id)
          .then(r => r.data || [])
          .catch(() => [])
      )
    )

    results.forEach(accounts =>
      accounts.forEach(account => {
        if (account.accountId) {
          owners[account.accountId] = { name: account.name }
        }
      })
    )
  } catch {
    // Leave the accounts unresolved rather than failing the caller.
  }

  return owners
}
